import { alpha, cardActionAreaClasses, hexToRgb } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const muiCardActionAreaComponent = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      height: '100%',

      [`&:hover`]: {
        background: `linear-gradient(0deg, ${alpha(hexToRgb(theme.palette.main.professional_blue), 0.15)} 0%, ${alpha(hexToRgb(theme.palette.main.professional_blue), 0.15)} 100%), ${theme.palette.common.white}`,

        [`.${cardActionAreaClasses.focusHighlight}`]: {
          opacity: 0,
          background: 'transparent',
        },
      },

      [`&:focus, &.Mui-focusVisible`]: {
        border: `3px solid ${theme.palette.main.professional_blue}`,

        [`.${cardActionAreaClasses.focusHighlight}`]: {
          opacity: 0,
          background: 'transparent',
        },
      },

      [`&.Mui-disabled`]: {
        opacity: 0.6,
      },
    }),
  },
};
